import { render, staticRenderFns } from "./DetailClassPrakerja.vue?vue&type=template&id=5178f873&"
import script from "./DetailClassPrakerja.vue?vue&type=script&lang=js&"
export * from "./DetailClassPrakerja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports